<template>
  <div id="card" class="card">
    <div class="img">
      <i :class="imagen"></i>
    </div>

    <div class="contenedor">
    <div class="titulo">
      {{title}}
    </div>

    <div class="contenido">
      {{contenido}}
    </div>
    <div class="botones" v-if="false">
      <div class="dvBoton">
        Ver mas...
      </div>
    </div>
    </div>

    <svg v-if="false">
      <line class="top" x1="0" y1="0" x2="1200" y2="0"/>
      <line class="left" x1="0" y1="330" x2="0" y2="-990"/>
    </svg>

  </div>
</template>

<script>
  import lorem from 'vue-lorem-ipsum';

   export default {
      name: "Card",
     components: {lorem},
     props: {
       imagen: {
         type: String,
         default: ""
       },
       contenido: {
         type: String,
         default: "Contenido"
       },
       title: {
         type: String,
         default: "Titulo"
       }
     }
   }
</script>

<style scoped lang="scss">
  @import "../../style/base";

  #card {
    @include flexColumn;
    width: 100%;
    box-shadow: 1px 2px 1px -14px #888888;
    @include Montserrat;
    padding: 10px;

    & .contenedor {
      @include flexColumn;
      @include absoluteCenter;
    }

    & .titulo {
      width: 100%;
      height: 40px;
      @include flexRow;
      @include absoluteCenter;
      color: #000000;
      font-weight: 600;
      letter-spacing: 1px;
      font-size: 18px;
      text-align: center;
      line-height: 1;
    }

    & .contenido {
      @include Montserrat;
      padding-bottom: 30px;
      margin: 20px;
      color: #3c3f40;
      text-align: center;
    }

    & .img{
      margin: 25px 0;
      @include flexRow;
      @include absoluteCenter;
      font-size: 45px;
      color: $colorSecundary;
    }


    & .botones {
      position: absolute;
      left: 50%;
      transform: translate(-50%,50%);
      bottom: 30px;
      opacity: 0;
      height: 0;
      transition: 0.5s all ease-in-out ;
    }

    &:HOVER {
      box-shadow: 1px 2px 14px -8px #888888;

      & .botones {
        opacity: 1;
        height: 30px;
        transition: 0.5s all ease-in-out;
        bottom: 0;
      }
    }

    svg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;

      & line {
        stroke-width: 2;
        stroke: #000;
        fill: none;
        stroke-dasharray: 400;
        transition: transform .6s ease-out;
      }
    }

    &:HOVER svg line {

      &.top {
        -webkit-transform: translateX(-800px);
        transform: translateX(-800px);
      }

      &.left {
        -webkit-transform: translateY(760px);
        transform: translateY(760px);
      }

    }

  }

</style>
